const SurveyMachine = () => (
  <svg height="30" id="survey-machine" viewBox="0 0 40 40" width="30" xmlns="http://www.w3.org/2000/svg">
    <g data-name="Calque 1" id="Calque_1">
      <rect data-name="Rectangle 599" fill="none" height="40" id="Rectangle_599" width="40" />
      <circle cx="20" cy="20" data-name="Ellipse 145" fill="none" id="Ellipse_145" r="20" transform="translate(0 0)" />
      <line data-name="Ligne 341" fill="none" id="Ligne_341" x2="40" y2="40" />
      <line data-name="Ligne 342" fill="none" id="Ligne_342" x1="40" y2="40" />
      <line data-name="Ligne 343" fill="none" id="Ligne_343" transform="translate(0 20)" x2="40" />
      <line data-name="Ligne 344" fill="none" id="Ligne_344" transform="translate(0 9.997)" x2="40" />
      <line data-name="Ligne 345" fill="none" id="Ligne_345" transform="translate(0 30.002)" x2="40" />
      <line data-name="Ligne 346" fill="none" id="Ligne_346" transform="translate(20)" y2="40" />
      <line data-name="Ligne 347" fill="none" id="Ligne_347" transform="translate(9.997)" y2="40" />
      <line data-name="Ligne 348" fill="none" id="Ligne_348" transform="translate(30.002)" y2="40" />
      <rect
        data-name="Rectangle 600"
        fill="none"
        height="28.291"
        id="Rectangle_600"
        transform="translate(5.855 5.855)"
        width="28.291"
      />
      <circle
        cx="14.145"
        cy="14.145"
        data-name="Ellipse 146"
        fill="none"
        id="Ellipse_146"
        r="14.145"
        transform="translate(5.855 5.855)"
      />
      <rect
        data-name="Rectangle 601"
        fill="none"
        height="20.005"
        id="Rectangle_601"
        transform="translate(9.997 9.997)"
        width="20.005"
      />
      <circle
        cx="10.002"
        cy="10.002"
        data-name="Ellipse 147"
        fill="none"
        id="Ellipse_147"
        r="10.002"
        transform="translate(9.998 9.998)"
      />
      <g data-name="Calque 1-2" id="Calque_1-2">
        <path
          d="M26.44,18.311a1.653,1.653,0,1,0,1.653,1.653h0A1.677,1.677,0,0,0,26.44,18.311Z"
          data-name="Tracé 12"
          fill="none"
          id="Tracé_12"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.019"
        />
        <path
          d="M33.482,18.214a7.25,7.25,0,0,0-8.79-5.25c-.119.039-.216.058-.34.1-1.557.34-1.984.584-3.521.934-2.3.545-2.937-.777-4.493-.273-.973.312-1.614.467-2.217-.039a1.932,1.932,0,0,0,2.256,1.575c1.244-.058,1.557.954.8,1.614-.952.849-1.713-.428-2.957-.564a2.5,2.5,0,0,0-2.665,1.38c1.188-.72,2.646-.311,2.628.6s-1.3,1.555-3.015.757c-1.575-.738-3.056-.525-4.882,1.246,2.3-.584,2.86-.428,3.638.35a3.359,3.359,0,0,0,3.385.874c1.283-.389,2.061.584,1.03,1.188-1.226.679-2.412-.584-4.395.934a2.614,2.614,0,0,1,2.8.234,3.431,3.431,0,0,0,3.366-.158c1.358-.757,1.984.759.895,1.439A3.132,3.132,0,0,1,14.142,25c1.635,2.546,3.774,1.069,5.912,1.129,2.219.078,3.056.913,5.972,1.127l-.136-.039a7.238,7.238,0,0,0,7.778-6.658v-.02a6.719,6.719,0,0,0-.2-2.334Zm-2.159,2.314a.263.263,0,0,1-.292.233h-.058a1.115,1.115,0,0,0-1.019.662,1.08,1.08,0,0,0,.275,1.226.275.275,0,0,1,.039.37,5.128,5.128,0,0,1-.8.8.255.255,0,0,1-.36-.027l-.01-.012a1.1,1.1,0,0,0-1.906.777.292.292,0,0,1-.253.292,5.244,5.244,0,0,1-1.107,0,.263.263,0,0,1-.234-.289h0a1.086,1.086,0,0,0-.662-1.069,1.142,1.142,0,0,0-1.224.272.272.272,0,0,1-.37.039,5,5,0,0,1-.777-.8.255.255,0,0,1,.025-.36l.014-.01a1.1,1.1,0,0,0-.738-1.906.34.34,0,0,1-.34-.233,5.228,5.228,0,0,1,0-1.129.261.261,0,0,1,.289-.233h0a1.137,1.137,0,0,0,1.071-.662,1.108,1.108,0,0,0-.273-1.244.272.272,0,0,1-.039-.37,5.14,5.14,0,0,1,.8-.8.253.253,0,0,1,.358.027l.01.012a1.142,1.142,0,0,0,1.227.275,1.1,1.1,0,0,0,.679-1.049.263.263,0,0,1,.25-.275h0a5.262,5.262,0,0,1,1.108,0,.263.263,0,0,1,.234.292,1.1,1.1,0,0,0,.66,1.09,1.146,1.146,0,0,0,1.226-.275.275.275,0,0,1,.37-.039,5,5,0,0,1,.774.8.255.255,0,0,1-.027.36l-.012.01a1.081,1.081,0,0,0-.087,1.528h.008a1.054,1.054,0,0,0,.835.35.316.316,0,0,1,.312.234,3.648,3.648,0,0,1,0,1.129Z"
          data-name="Tracé 13"
          fill="none"
          id="Tracé_13"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.019"
        />
      </g>
    </g>
  </svg>
);

export default SurveyMachine;
